var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"m384 85.333 85.333 85.334v256H42.667V85.333H384ZM373.333 128h-288v256h341.334V181.333L373.333 128Zm-224 42.667v149.332L384 320v21.333H128V170.667h21.333Zm64 64v64h-42.666v-64h42.666Zm64-42.667v106.667h-42.666V192h42.666Zm64 64v42.667h-42.666V256h42.666Z","fill-rule":"evenodd"}})
}
var staticRenderFns = []

export { render, staticRenderFns }